import { useState } from 'react';
import { useParams } from 'react-router-dom';
import Dompurify from 'dompurify';

import { FAQ_DATA } from '@lib/DUMMY';

import { Wrapper, EditorContents } from '@components/styled/StyledComponents';
import { InfoSection } from '@components/share/Info/InfoSection';
import Headline from '@components/layout/Headline';
import Loader from '@components/share/Loader';

const FaqDetail = () => {
    const { id } = useParams();
    const [loading, setLoading] = useState(false);

    if (loading) return <Loader />;
    return (
        <Wrapper>
            <Headline
                title={FAQ_DATA[+(id as string) - 1].title}
                subTitle={FAQ_DATA[+(id as string) - 1].category}
                GO_BACK
            />
            <InfoSection>
                <EditorContents
                    dangerouslySetInnerHTML={{
                        __html: Dompurify.sanitize(
                            FAQ_DATA[+(id as string) - 1].title || ''
                        )
                    }}
                />
            </InfoSection>
        </Wrapper>
    );
};

export default FaqDetail;
